import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import EditIcon from "@material-ui/icons/Edit";
import { useEffect, useState } from "react";
import { LuArrowLeft, LuPlus } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ActionMenu from "../../../common/ActionMenu";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomConfirm from "../../../components/Common/CustomConfirmModal";
import AddNewOrg from "../../../components/Dashboard/AddNewOrg";
import {
  getCurrentUserId,
  isAdminLogin,
  isSuperAdminLogin,
  toastError,
  toastSuccess,
} from "../../../utils";
import * as actions from "./actions";

const inititalOrganization = {
  organizationAdmin: "",
  domain: "",
  organizationType: "",
  organizationName: "",
};

function SetupOrganization(props) {
  const { setLoader = () => { } } = props;

  const dispatch = useDispatch();
  const { allOrganization = [] } = useSelector((state) => state.dashboard);
  const history = useHistory();
  const [organization, setOrganization] = useState({ ...inititalOrganization });
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [saveLabel, setSaveLabel] = useState("Add");
  const [selectedOrg, setSelectedOrg] = useState({ id: "", status: "" });

  useEffect(() => {
    const organizationAdmin = isAdminLogin()
      ? { organizationAdmin: getCurrentUserId() }
      : {};
    if (allOrganization.length) {
      dispatch(actions.getAllOrganizations(organizationAdmin));
    }
  }, []);

  const onCloseModal = () => {
    setOpen(false);
    setOrganization({ ...inititalOrganization });
    setSaveLabel("Add");
  };

  const onChangeHandler = (e) => {
    const { name = "", value = "" } = e.target;
    setOrganization({ ...organization, [name]: value });
  };

  const onOpenConfirm = (status, id) => {
    setSelectedOrg({ id, status });
    setOpenConfirm(true);
  };

  const onSubmitConfirm = async () => {
    try {
      setLoader(true);

      if (saveLabel === "Add") {
        const data = {
          ...organization,
          organizationAdmin: isAdminLogin()
            ? getCurrentUserId()
            : organization.organizationAdmin,
        };
        await actions.createOrganization(data);
        toastSuccess("Organization created successfully");
      } else {
        const { _id, ...organizationData } = organization;
        await actions.updateOrganization({
          id: _id,
          data: {
            ...organizationData,
            organizationAdmin: isAdminLogin()
              ? getCurrentUserId()
              : organization.organizationAdmin,
          },
        });
        toastSuccess("Organization updated successfully");
      }

      const organizationAdmin = isAdminLogin()
        ? { organizationAdmin: getCurrentUserId() }
        : {};
      dispatch(actions.getAllOrganizations(organizationAdmin));

      onCloseModal();
      setLoader(false);
    } catch (err) {
      setLoader(false);
      toastError(err?.data?.message);
    }
  };

  const onClickEdit = (org = {}) => {
    const {
      _id = "",
      domain = "",
      organizationAdmin = "",
      organizationType = "",
      organizationName = "",
    } = org;
    setOrganization({
      _id,
      organizationAdmin: organizationAdmin?._id,
      domain,
      organizationType,
      organizationName,
    });
    setSaveLabel("Update");
    setOpen(true);
  };

  const onSubmitStatus = async () => {
    try {
      setLoader(true);
      const orgId = selectedOrg.id;
      await actions.updateOrganizationStatus({
        id: orgId,
        action: selectedOrg?.status === "activate" ? "activate" : "deactivate",
      });
      setSelectedOrg({ id: "", status: "" });
      setOpenConfirm(false);
      const organizationAdmin = isAdminLogin()
        ? { organizationAdmin: getCurrentUserId() }
        : {};
      dispatch(actions.getAllOrganizations(organizationAdmin));
      setLoader(false);
    } catch (ex) {
      setLoader(false);
      toastError(ex?.data?.message);
    }
  };

  return (
    <Grid container alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
      <Grid item xs={12}>
        <div className="flex flex-wrap items-center justify-between w-full gap-2 mb-2">
          <button
            onClick={() => history.goBack()}
            className="h-7 px-3 bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 text-[11px] font-medium rounded-none flex items-center justify-center gap-1.5 shadow-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            <LuArrowLeft size={14} /> Go back
          </button>
          <button
            onClick={() => setOpen(true)}
            className="h-7 px-3 bg-[#313C4C] hover:bg-[#1e2632] text-white text-[11px] font-medium rounded-none flex items-center justify-center gap-1.5 shadow-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            <LuPlus size={14} /> Create Organization
          </button>
        </div>
      </Grid>
      <Grid item xs={12}>
        <Box pt={0.5}>
          <TableContainer component={Paper} className="!rounded-none !shadow-sm">
            <Table className="universal-table">
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Organization Id</TableCell>
                  <TableCell>Organization Admin</TableCell>
                  <TableCell>Domain</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(allOrganization) && allOrganization.length ? (
                  allOrganization.map((item, index) => {
                    return (
                      <TableRow
                        key={index}
                        className="cursor-pointer hover:bg-gray-50"
                        onDoubleClick={() => onClickEdit(item)}
                      >
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{item.organizationName}</TableCell>
                        <TableCell className="!text-slate-500">{item._id}</TableCell>
                        <TableCell>
                          {item.organizationAdmin?.firstName ||
                            item.organizationAdmin?.lastName
                            ? `${item.organizationAdmin?.firstName} ${item.organizationAdmin?.lastName}`
                            : "N/A"}
                        </TableCell>
                        <TableCell>{item.domain || "N/A"}</TableCell>
                        <TableCell>
                          <span
                            className={`tb-status tb-status-${item.isActive ? "success" : "danger"
                              }`}
                          >{item.isActive ? "Active" : "Inactive"}</span>
                        </TableCell>
                        <TableCell className="user-organization-actions">
                          <ActionMenu
                            options={[
                              {
                                label: "Edit",
                                onClick: () => onClickEdit(item),
                                icon: <EditIcon className={isSuperAdminLogin() ? "!text-slate-600" : "!text-lightBlue"} />,
                              },
                              {
                                label: "Activate",
                                icon: isSuperAdminLogin() && <CheckCircleIcon className="!text-emerald-600" />,
                                onClick: () =>
                                  onOpenConfirm("activate", item._id),
                                hide:
                                  item.role === "superadmin" || item.isActive,
                              },
                              {
                                label: "Deactivate",
                                icon: isSuperAdminLogin() && <BlockIcon className="!text-rose-600" />,
                                onClick: () =>
                                  onOpenConfirm("deactivate", item._id),
                                hide:
                                  item.role === "superadmin" || !item.isActive,
                              },
                            ]}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={7} className="!bg-white">
                      No Organizations Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
      <CustomAddModal
        open={open}
        saveLabel={saveLabel}
        maxWidth="xs"
        title={`${saveLabel === "Add" ? "Add" : "Edit"} Organization`}
        handleClose={onCloseModal}
        onSubmitConfirm={onSubmitConfirm}
      >
        <AddNewOrg organization={organization} onChange={onChangeHandler} isEdit={saveLabel === "Update"} />
      </CustomAddModal>
      <CustomConfirm
        open={openConfirm}
        message={`Please confirm if you want to ${selectedOrg.status === "activate" ? "activate" : "deactivate"
          } organization`}
        confirmText={selectedOrg.status === "activate" ? "Activate" : "Deactivate"}
        onSubmitConfirm={onSubmitStatus}
        handleClose={() => setOpenConfirm(false)}
      >
        <div>hello</div>
      </CustomConfirm>
    </Grid>
  );
}

export default SetupOrganization;
